import Icon from "../../utils/Icon"

export const PromptCard = ({item, ...props}) => {
    return (
        <div className="prompt_card_container">
            <div className="prompt_card_item">
                <Icon name={item.aiIcon}/>
                <div className="text_hint" style={{paddingTop: 8}}>{item.desc}</div>
            </div>
        </div>
    )
}